import request from '@/utils/request';

export function getBase() {
    return request({
        url: `/mavin/base`,
        method: 'get'
    });
}

export function updateBase(mavinEid, data) {
    if (mavinEid) {
        return request({
            url: `/mavin/base/${mavinEid}`,
            method: 'put',
            data: data
        });
    } else {
        return request({
            url: `/mavin/base`,
            method: 'post',
            data: data
        });
    }
}

export function getStar(mavinEid) {
    return request({
        url: `/mavin/base/star/${mavinEid}`,
        method: 'get'
    });
}

export function updateStar(mavinEid, data) {
    return request({
        url: `/mavin/base/star/${mavinEid}`,
        method: 'post',
        data: data
    });
}

export function getAppraise(mavinEid) {
    return request({
        url: `/mavin/base/appraise/${mavinEid}`,
        method: 'get'
    });
}

export function updateAppraise(mavinEid, data) {
    return request({
        url: `/mavin/base/appraise/${mavinEid}`,
        method: 'post',
        data: data
    });
}